import { runAuthMiddleware } from '~/features/auth/model/runAuthMiddleware'

export default defineNuxtRouteMiddleware(async (to, from) => runAuthMiddleware(to, from))